import CastButton from "../CastButton";

const yt = (u) => u.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|live\/|embed\/))([\w-]{6,})/)?.[1];

export default function EventVideo({ url, title }) {
  if (!url) return null;
  const id = yt(url);
  return (
    <div className="space-y-2" data-testid="event-video">
      <div className="rounded-xl overflow-hidden border border-slate-800 bg-black aspect-video">
        {id ? <iframe title={title} src={`https://www.youtube.com/embed/${id}`} allow="autoplay; encrypted-media; picture-in-picture" allowFullScreen className="w-full h-full" data-testid="event-video-youtube" />
          : <video src={url} controls playsInline preload="metadata" className="w-full h-full" data-testid="event-video-player" />}
      </div>
      <div className="flex items-center justify-between gap-2">
        <p className="text-[11px] font-mono tracking-widest text-slate-500">{id ? "LIVE / RECORDING" : "RECORDING"}</p>
        {id ? <a href={url} target="_blank" rel="noreferrer" className="text-xs text-cyan-300 underline" data-testid="event-video-open">Open on YouTube (cast from the YouTube app)</a> : <CastButton url={url} title={title} testId="event-cast-button" />}
      </div>
    </div>
  );
}
